module.exports = __webpack_public_path__ + "img/terroir-choppy-3-mobile.06d58b65.jpg";